import React, { useState } from "react";
import axios from "axios";
import "./ContactOrder.css";

const ContactOrder = () => {
  const [orderForm, setOrderForm] = useState({
    name: "",
    email: "",
    phone: "",
    package: "1mg-starter",
    quantity: 1,
    message: ""
  });
  const [orderStatus, setOrderStatus] = useState({ type: "", message: "" });
  const [orderLoading, setOrderLoading] = useState(false);

  const backendUrl = process.env.REACT_APP_BACKEND_URL;
  const whatsappNumber = "447908659005"; // UK WhatsApp business number

  const handleOrderSubmit = async (e) => {
    e.preventDefault();
    setOrderLoading(true);
    setOrderStatus({ type: "", message: "" });

    try {
      await axios.post(`${backendUrl}/api/order-inquiry`, orderForm);
      setOrderStatus({ 
        type: "success", 
        message: "Order inquiry received! Our team will contact you within 24 hours to complete your order." 
      });
      setOrderForm({ 
        name: "", 
        email: "", 
        phone: "", 
        package: "1mg-starter", 
        quantity: 1, 
        message: "" 
      });
    } catch (error) {
      setOrderStatus({ 
        type: "error", 
        message: "Something went wrong. Please try again or contact us directly." 
      });
    } finally {
      setOrderLoading(false);
    }
  };

  const handleWhatsAppOrder = () => {
    window.open(`https://wa.me/${whatsappNumber}`, '_blank');
  };

  return (
    <section id="contact" className="contact-order-section">
      <div className="container">
        <div className="section-header">
          <h2 className="section-title">Place Your Order</h2>
        </div>

        <div className="order-buttons-container">
          <button className="order-method-btn enquiry-btn" onClick={() => document.getElementById('order-form-section').scrollIntoView({ behavior: 'smooth' })}>
            📋 Order Inquiry Form
          </button>
          <button className="order-method-btn whatsapp-btn" onClick={handleWhatsAppOrder}>
            💬 Order by WhatsApp
          </button>
        </div>

        <div id="order-form-section" className="forms-container">
          <form className="order-form" onSubmit={handleOrderSubmit}>
              <div className="form-grid">
                <div className="form-group">
                  <label>Full Name *</label>
                  <input
                    type="text"
                    required
                    value={orderForm.name}
                    onChange={(e) => setOrderForm({...orderForm, name: e.target.value})}
                    placeholder="John Doe"
                  />
                </div>
                <div className="form-group">
                  <label>Email *</label>
                  <input
                    type="email"
                    required
                    value={orderForm.email}
                    onChange={(e) => setOrderForm({...orderForm, email: e.target.value})}
                    placeholder="john@example.com"
                  />
                </div>
              </div>
              <div className="form-group">
                <label>Phone Number *</label>
                <input
                  type="tel"
                  required
                  value={orderForm.phone}
                  onChange={(e) => setOrderForm({...orderForm, phone: e.target.value})}
                  placeholder="(555) 123-4567"
                />
              </div>
              <div className="form-grid">
                <div className="form-group">
                  <label>Select Package *</label>
                  <select
                    required
                    value={orderForm.package}
                    onChange={(e) => setOrderForm({...orderForm, package: e.target.value})}
                  >
                    <option value="1mg-starter">1mg Starter Pack - 1 Pen, 4x1mg shots (£99)</option>
                    <option value="2mg-standard">2mg Standard Pack - 1 Pen, 4x2mg shots (£176)</option>
                    <option value="8mg-premium">8mg Premium Pack - 1 Pen, 4x8mg shots (£227)</option>
                  </select>
                </div>
                <div className="form-group">
                  <label>Quantity</label>
                  <input
                    type="number"
                    min="1"
                    value={orderForm.quantity}
                    onChange={(e) => setOrderForm({...orderForm, quantity: parseInt(e.target.value)})}
                  />
                </div>
              </div>
              <div className="form-group">
                <label>Additional Notes</label>
                <textarea
                  rows="4"
                  value={orderForm.message}
                  onChange={(e) => setOrderForm({...orderForm, message: e.target.value})}
                  placeholder="Any special requests or questions?"
                />
              </div>
              {orderStatus.message && (
                <div className={`form-status ${orderStatus.type}`}>
                  {orderStatus.message}
                </div>
              )}
              <button type="submit" className="submit-btn" disabled={orderLoading}>
                {orderLoading ? "Submitting..." : "Submit Order Inquiry"}
              </button>
              <p className="form-note">
                Note: This is an inquiry form. Our team will contact you to complete the order process.
              </p>
            </form>
        </div>
      </div>
    </section>
  );
};

export default ContactOrder;